import React from 'react';
import { useNavigate } from 'react-router-dom';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../Shared/pr-s-black';
import '../Assets/Stylesheets/Pages/Agencies.scss';

export default function Agencies() {
  const navigate = useNavigate();
  
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const benefits = [
    {
      id: 1,
      title: 'Expanded Service Offerings',
      description: 'Effortlessly add a wide range of digital marketing services to your portfolio.',
      icon: '🚀'
    },
    {
      id: 2,
      title: 'Enhanced Profit Margins',
      description: 'Enjoy discounted rates and improve your profitability on every project.',
      icon: '💰'
    },
    {
      id: 3,
      title: 'Streamlined Operations',
      description: 'We take care of service delivery, leaving you to concentrate on client acquisition and management.',
      icon: '⚡'
    },
    {
      id: 4,
      title: 'Dedicated Support',
      description: 'Benefit from dedicated account management and priority handling for your projects.',
      icon: '🤝'
    },
    {
      id: 5,
      title: 'Scalable Growth',
      description: 'Scale your business effortlessly with our infrastructure and resources at your fingertips.',
      icon: '📈'
    },
    {
      id: 6,
      title: 'Brand Credibility',
      description: 'Leverage our established reputation and trusted network to strengthen your brand.',
      icon: '🏆'
    }
  ];

  const steps = [
    {
      number: 1,
      title: 'Apply to Join',
      description: 'Start by submitting your application. We will review your business details and credentials.'
    },
    {
      number: 2,
      title: 'Onboarding & Integration',
      description: 'Once approved, we will guide you through the onboarding process, setting you up to offer services to clients.'
    },
    {
      number: 3,
      title: 'Connect with Clients',
      description: 'Gain access to a steady stream of client opportunities and leverage our marketing resources.'
    },
    {
      number: 4,
      title: 'Deliver & Grow',
      description: 'Focus on delivering exceptional service. We handle everything from client acquisition to fulfillment while allowing you to scale profitably.'
    }
  ];

  const handleApplyClick = () => {
    navigate('/contact');
  };

  return (
    <div id="agencies-page">
      {/* Hero Section */}
      <section className="agencies-hero">
        <div className="particles circle-bg">
          <div className="container">
            <div className="title-box">
              <h6>PARTNERSHIP PROGRAM</h6>
              <h1>
                <span className="color-font">Join TRND</span> Marketplace
              </h1>
              <h1>
                as an <span className="color-font">Agency Partner</span>
              </h1>
              <p className="hero-subtitle">Elevate Your Business with TRND Marketplace</p>
              <button className="apply-button" onClick={handleApplyClick}>
                APPLY NOW
              </button>
            </div>
          </div>

          <Particles
            id="particles-js"
            init={particlesInit}
            options={particlesConfig}
          />

          <div className="gradient-circle"></div>
          <div className="gradient-circle two"></div>
        </div>
      </section>

      {/* Opportunities Section */}
      <section className="opportunities-section">
        <div className="container">
          <h2><span className="color-font">Expanding Opportunities</span> for Agencies and Vendors</h2>
          <div className="opportunities-content">
            <p>Welcome to the TRND Marketplace Agency Partner Program. This unique initiative is designed to help agencies and independent vendors looking to enhance their service offerings while increasing profitability.</p>
            <p>As an Agency Partner, whether you are an agency acting as a middleman or a service provider, you will benefit from our extensive network of pre-vetted vendors, premium clients, and the ability to grow your profitability while maintaining the quality and integrity of our services.</p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2><span className="color-font">Why Partner</span> with Us?</h2>
          <div className="benefits-grid">
            {benefits.map((benefit) => (
              <div key={benefit.id} className="benefit-card">
                <div className="benefit-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works-section">
        <div className="container">
          <h2>How It Works: <span className="color-font">Simple, Seamless, Rewarding</span></h2>
          <div className="steps-container">
            {steps.map((step) => (
              <div key={step.number} className="step-card">
                <div className="step-number">{step.number}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ready to Amplify Section */}
      <section className="ready-section">
        <div className="container">
          <div className="ready-content">
            <h2>Ready to <span className="color-font">Amplify</span> Your Business?</h2>
            <p>We are eager to partner with agencies and vendors who are experts in their field, passionate about delivering results, and ready to join a community of growth-focused professionals.</p>
            <p>If you are looking to scale your operations, increase your offerings, and enhance your profitability, TRND Marketplace is your ideal partner.</p>
            <button className="apply-button" onClick={handleApplyClick}>
              BECOME A PARTNER
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
